'use strict';

// Cold Brew Dilution — pure calculation (Monarch → Knowledge → Tools).
// One relationship, C1·V1 = C2·V2, solved for whichever number is missing.
// Kept here in shared/ (no state, no I/O) so the UI, its tests, and the
// future server-side batch logging (spec P2/R9) all use ONE implementation.
//
//   dilute({ mode:'water',       concentrateOz, concentrateTDS, targetTDS })
//     → how much WATER to add to a batch of concentrate.
//   dilute({ mode:'concentrate', finalVolume,   concentrateTDS, targetTDS })
//     → how much CONCENTRATE (and water) to make a target batch size.
//
// TDS is a percentage number (4.0 means 4%). Volumes are ounces. Filtered
// water is assumed to be 0% TDS.

function toNum(v) {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  if (s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

function dilute(input) {
  const cTDS = toNum(input && input.concentrateTDS);
  const tTDS = toNum(input && input.targetTDS);
  const primary = input && input.mode === 'water'
    ? toNum(input.concentrateOz)
    : toNum(input && input.finalVolume);

  if (primary === null || cTDS === null || tTDS === null) {
    return { ok: false, error: 'Please fill in all three fields.' };
  }
  if (primary <= 0) {
    return {
      ok: false,
      error: input.mode === 'water'
        ? 'Concentrate volume must be more than 0 oz.'
        : 'Final volume must be more than 0 oz.',
    };
  }
  if (cTDS <= 0 || tTDS <= 0) return { ok: false, error: 'TDS must be more than 0%.' };
  if (tTDS >= cTDS) return { ok: false, error: 'Final TDS must be lower than concentrate TDS.' };

  if (input.mode === 'water') {
    const finalVolume = (cTDS * primary) / tTDS;
    return {
      ok: true, mode: 'water',
      concentrate: primary, water: finalVolume - primary, finalVolume,
      concentrateTDS: cTDS, targetTDS: tTDS,
    };
  }
  const concentrate = (tTDS * primary) / cTDS;
  return {
    ok: true, mode: 'concentrate',
    concentrate, water: primary - concentrate, finalVolume: primary,
    concentrateTDS: cTDS, targetTDS: tTDS,
  };
}

module.exports = { dilute, toNum };
